import { render } from "./Model-7xl.vue?vue&type=template&id=c8fae13e"
import script from "./Model-7xl.vue?vue&type=script&lang=js"
export * from "./Model-7xl.vue?vue&type=script&lang=js"
script.render = render

export default script